var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEtherScan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#clip0_1_2169)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.579 9.531a.75.75 0 01.238-.55.814.814 0 01.576-.227l1.349.004a.83.83 0 01.574.228.762.762 0 01.237.55v4.894c.152-.043.347-.09.56-.137a.68.68 0 00.376-.229.632.632 0 00.146-.402v-6.07c0-.207.085-.405.238-.55a.83.83 0 01.573-.228H10.8a.83.83 0 01.573.227.762.762 0 01.238.55v5.635s.338-.132.668-.265a.672.672 0 00.3-.24.63.63 0 00.113-.358V5.647c0-.207.086-.405.238-.55a.83.83 0 01.574-.228h1.352a.83.83 0 01.573.228.762.762 0 01.237.55v5.53c1.172-.814 2.36-1.794 3.303-2.973a1.255 1.255 0 00.207-1.22 9.096 9.096 0 00-2.036-3.239 9.561 9.561 0 00-3.229-2.174 9.903 9.903 0 00-3.868-.737 9.892 9.892 0 00-3.85.825A9.535 9.535 0 003.02 3.906a9.071 9.071 0 00-1.956 3.286 8.804 8.804 0 00-.405 3.763 8.9 8.9 0 001.216 3.599c.115.19.285.345.49.447.203.101.433.145.662.125.256-.022.575-.052.953-.095a.685.685 0 00.427-.212.633.633 0 00.172-.43V9.53zM4.55 17.379a9.806 9.806 0 004.866 1.724 9.902 9.902 0 005.088-.969 9.413 9.413 0 003.81-3.377 8.884 8.884 0 001.408-4.789c0-.211-.01-.42-.025-.627-3.49 4.993-9.935 7.327-15.147 8.038z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2169"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H19.116V18.333H0z",
    transform: "translate(.606 .833)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtherScan);
export default __webpack_public_path__ + "static/media/etherScan.302273b69984b549273e5a637957d24b.svg";
export { ForwardRef as ReactComponent };